import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "../../../../../styles";
import { fixedTable } from "../../../../../styles/utils.css";
import {
  cellStyles,
  columnStyles,
  stickyCellStyles,
  stickyColumnStyles,
  stickyHeaderCell,
  tableStyles,
} from "../../../../Table/tables.css";

export const wrapperContainer = style({
  display: "grid",
  gap: vars.space.m,
});

export const toggleWrapper = style({
  width: "100%",
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      margin: "0 auto",
      width: "40%",
    },
  },
});

export const playerStatsTableStyles = style([tableStyles, fixedTable]);

export const statColStyles = style([
  columnStyles,
  stickyHeaderCell,
  {
    width: 55,
    textAlign: "center",
  },
]);

export const statusColStyles = style([
  columnStyles,
  {
    width: 40,
    textAlign: "center",
  },
]);

export const playerColStyles = style([
  stickyColumnStyles,
  stickyHeaderCell,
  {
    zIndex: vars.zIndex.table.firstStickyCol,
    width: 180,
    "@media": {
      [`screen and (min-width:${breakpoints[1]})`]: {
        width: 200,
      },
    },
  },
]);

export const playerCellStyles = style([
  stickyCellStyles,
  {
    borderBottom: "none",
    padding: 0,
    selectors: {
      "&::after": {
        position: "absolute",
        top: "50%",
        insetInlineEnd: 0,
        transform: "translateY(-50%)",
        backgroundColor: vars.colors.outlineVariant,
        width: 1,
        height: `calc(100% - ${vars.space.xs} * 2)`,
        content: '""',
      },
    },
  },
]);

export const statsCellStyles = style([
  cellStyles,
  {
    textAlign: "center",
  },
]);

export const skeletonCellStyles = style({
  margin: vars.space.xs,
  borderRadius: vars.radii.m,
  backgroundColor: vars.colors.tonal,
  height: 16,
});

export const playerRowStyles = style({
  borderBottom: vars.borders.outlineVariant,
});
